import {
  LayoutDashboard,
  ClipboardList,
  ClipboardCheck,
  Trophy,
  Users,
  Trophy as Circuit,
  DollarSign,
  Tags,
  Layers,
  Percent,
  MapPin,
  Award,
  Ticket,
  Megaphone,
  Table2,
  Image as ImageIcon,
  Mail,
  Palette,
  Shield,
  User,
  Settings,
  ToggleLeft,
  Building2,
  UserCog,
} from "lucide-react";
import type { ShellNavGroup, ShellNavItem } from "@/components/shell/AppShell";

/**
 * Navigation for the PLATFORM ADMIN area.
 * All items are visible, organized into labeled groups (no "More" collapsible).
 * Routes are unchanged from the previous sidebar — this is purely presentation.
 */
export const platformAdminNav: ShellNavGroup[] = [
  {
    items: [{ label: "Dashboard", href: "/admin-dashboard", icon: LayoutDashboard }],
  },
  {
    label: "Manage",
    items: [
      { label: "Events", href: "/admin-dashboard/events", icon: Trophy },
      { label: "Registrations", href: "/admin-dashboard/registrations", icon: ClipboardList },
      { label: "Teams", href: "/admin/teams/merge", icon: Users },
      { label: "Circuits", href: "/admin-dashboard/circuits", icon: Circuit },
      { label: "Records", href: "/admin-dashboard/records", icon: ClipboardCheck },
      { label: "Shared Sheet Links", href: "/admin/live-sheets", icon: Table2 },
      { label: "Money", href: "/admin-dashboard/events/finance", icon: DollarSign },
      { label: "Organizations", href: "/admin-dashboard/organizations", icon: Building2 },
      { label: "Staff", href: "/admin-dashboard/staff", icon: UserCog },
    ],
  },
  {
    label: "Setup",
    items: [
      { label: "Event Categories", href: "/admin-dashboard/event-categories", icon: Tags },
      { label: "Divisions", href: "/admin-dashboard/divisions", icon: Layers },
      { label: "Discount Policies", href: "/admin-dashboard/event-discount-policies", icon: Percent },
      { label: "Venues", href: "/admin-dashboard/venues", icon: MapPin },
      { label: "Sponsors", href: "/admin-dashboard/event-sponsors", icon: Award },
      { label: "Coupons", href: "/admin-dashboard/coupons", icon: Ticket },
    ],
  },
  {
    label: "Advertising",
    items: [
      { label: "Banners & Ads", href: "/admin-dashboard/advertising", icon: Megaphone },
    ],
  },
  {
    label: "Communication",
    items: [
      { label: "Templates", href: "/admin-dashboard/communication/templates", icon: Mail },
      { label: "Branding (Headers & Footers)", href: "/admin-dashboard/communication/branding", icon: Palette },
    ],
  },
  {
    label: "Design",
    items: [
      { label: "Sport Cover Photos", href: "/admin-dashboard/sport-cover-photos", icon: ImageIcon },
    ],
  },
  {
    label: "Data",
    items: [
      { label: "Master Teams", href: "/admin-dashboard/master-teams", icon: Shield },
      { label: "Players", href: "#", icon: User },
    ],
  },
];

/** Pinned to the bottom of the sidebar. */
export const platformAdminFooterNav: ShellNavItem[] = [
  { label: "Modules", href: "/admin-dashboard/modules", icon: ToggleLeft },
  { label: "Settings", href: "/admin-dashboard/settings", icon: Settings },
];
